import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styled from 'styled-components';

const NudgeGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1px;
`;

const StyledIconButton = styled(IconButton)`
    && {
        padding: 1px;
        border-radius: 3px;
        color: ${({ disabled }) => (disabled ? '#555' : '#aaa')};

        &:hover {
            color: #4a9eff;
            background-color: rgba(74, 158, 255, 0.08);
        }
    }
`;

const NUDGE_AMOUNT = 0.1; // 100ms

/**
 * TimecodeNudgeButtons
 * Props:
 *   sub        — current subtitle object
 *   updateSub  — function(sub, patch) from SubtitleEditorV2
 *   player     — player ref (player.element is the <video> element)
 *   field      — 'start' | 'end'
 *   readOnly   — disables buttons when true
 */
export default function TimecodeNudgeButtons({ sub, updateSub, player, field, readOnly }) {
    const handleNudge = (delta) => {
        if (!sub || readOnly) return;

        if (field === 'start') {
            const newStart = sub.startTime + delta;
            if (newStart < 0) return;
            if (newStart >= sub.endTime - 0.2) return;
            updateSub(sub, {
                start: sub.start,  // keep raw string — updateSub rebuilds from startTime
                startTime: newStart,
            });
            if (delta < 0 && player?.element) {
                player.element.currentTime = newStart;
            }
        } else {
            const newEnd = sub.endTime + delta;
            if (newEnd <= sub.startTime + 0.2) return;
            updateSub(sub, {
                end: sub.end,
                endTime: newEnd,
            });
        }
    };

    return (
        <NudgeGroup>
            <Tooltip title="+100ms" placement="top" arrow>
                <span>
                    <StyledIconButton
                        size="small"
                        disabled={readOnly}
                        onClick={() => handleNudge(NUDGE_AMOUNT)}
                        tabIndex={-1}
                    >
                        <ChevronRightIcon sx={{ fontSize: 14 }} />
                    </StyledIconButton>
                </span>
            </Tooltip>
            <Tooltip title="-100ms" placement="bottom" arrow>
                <span>
                    <StyledIconButton
                        size="small"
                        disabled={readOnly}
                        onClick={() => handleNudge(-NUDGE_AMOUNT)}
                        tabIndex={-1}
                    >
                        <ChevronLeftIcon sx={{ fontSize: 14 }} />
                    </StyledIconButton>
                </span>
            </Tooltip>
        </NudgeGroup>
    );
}
